module.exports = __webpack_public_path__ + "1-es2015.worker.js"